import { ContactCard } from './ContactCard';
import { DealCard } from './DealCard';
import { PairCard } from './PairCard';

export const Card = {
  Contact: ContactCard,
  Deal: DealCard,
  Pair: PairCard,
};
